<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      left-arrow
      :title="$route.params.title || '周年庆活动详情'"
      z-index="10"
      @click-left="goableBack()" />
    <div class="contain-box">
      <img class="img-bg" :src="$route.params.detailImgs" />
      <div class="first-box">
        <img
          class="text-img"
          src="../../assets/img/my-redpack/anniversary/detials/activity_text_bg.png.png" />
        <div class="two-box">
          <img
            class="date-img"
            src="../../assets/img/my-redpack/anniversary/detials/activity_date_bg.png" />
          <div class="detial-bg">
            <img
              src="../../assets/img/my-redpack/anniversary/detials/activity_detial_bg.png" />
            <div class="info">
              您在活动期间累计年化投资金额：{{ activityAmountTotal }}元
            </div>
          </div>
          <img
            src="../../assets/img/my-redpack/anniversary/detials/activity_fuli1_bg.png" />
          <img
            class="last-img"
            src="../../assets/img/my-redpack/anniversary/detials/activity_fuli2_bg.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getYearAmount } from "../../api/lottery"
export default {
  data() {
    return {
      activityAmountTotal: 0
    }
  },
  mounted() {
    getYearAmount()
      .then((data) => {
        this.activityAmountTotal = data || 0
      })
      .catch((e) => {
        console.log("erroe: %O", e.msg)
      })
  }
}
</script>
<style lang="less" scoped>
.contain-box {
  position: relative;
  width: 100%;
  height: calc(100vh - 45px);
  overflow: hidden;
  .img-bg {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  .first-box {
    position: absolute;
    top: 0px;
    left: 10px;
    right: 10px;
    bottom: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    // background-color: aquamarine;
    .text-img {
      width: 100%;
      object-fit: fill;
      padding-bottom: 30px;
      padding-top: 180px;
    }
    .two-box {
      position: relative;
      margin: 0 20px;
      //   background-color: black;
      .date-img {
        margin: 0 30px;
        padding-bottom: 15px;
        width: calc(100% - 60px);
      }
      .detial-bg {
        position: relative;
        .info {
          position: absolute;
          top: 50px;
          bottom: 30px;
          left: 20px;
          right: 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: 14px;
        }
      }
      img {
        width: 100%;
        object-fit: fill;
        padding-bottom: 10px;
      }
      .last-img {
        padding-bottom: 20px;
      }
    }
  }
}
</style>